export type UserPerformanceRow = {
  id: string;
  name: string;
  role: string;
  division: string;
  assigned: number;
  escalated: number;
  completed: number;
};

export type CaseTrackingRow = {
  id: string;
  fileRef: string;
  fileCategory: string;
  subFileCategory: string;
  submittedAgency: string;
  submittedAt: string;
  workflowStage: string;
  allocationOfficer: string;
  assignedOfficer: string;
  supervisor: string;
  taskStatus: string;
  urgencyLevel: string;
};

export type WorkflowPerformanceRow = {
  id: string;
  workflowCode: string;
  workflowTemplateName: string;
  workflowTemplateStatus: string;
  fileCategory: string;
  subFileCategory: string;
  allocationOfficer: string;
  workflowStage: string;
  casesReceived: number;
  completed: number;
  inProgress: number;
  overdue: number;
  escalated: number;
};

export const REPORT_USER_ROLES = [
  'State Counsel',
  'Allocating Officer',
  'Supervising Officer',
  'Division Staff',
  'State Attorney',
  'Request Reviewer',
] as const;

export const REPORT_DIVISIONS = [
  'Criminal Division',
  'Civil Division',
  'CH Division',
  'Postal Division',
  'Civil Appellate Division',
  'High Court Division',
  'Supreme Court Division',
] as const;

export const REPORT_FILE_CATEGORIES = [
  'Criminal',
  'Civil Division',
  'Criminal Division – Litigation',
  'Civil Division – Advise',
  'Civil Division – Litigation',
  'Criminal Division – Advice',
  'Civil Litigation – Appellate Courts',
  'Extradition & Mutual Legal Assistance',
  'Criminal Litigation – Appellate Courts',
  'Right to Information',
  'Public Petitions',
  'Attorney General',
  'AGD – Internal',
  'Extradition & MLA',
  'Criminal Litigation – Appellate',
] as const;

export const REPORT_SUB_FILE_CATEGORIES = [
  'Offence Affecting Human Body/Life',
  'C – Action Instituted by State',
  'L – Land Acquisition',
  'CA – Actions Against State',
  'CH – Child Abuse',
  'C – Civil Appeal',
  'MLA – Treaty Request',
  'Offence Against Property',
  'RTI – State Entity',
  'PP – Fundamental Rights',
  'AG – Advisory Opinion',
  'L – Land Dispute',
  'Internal – Admin',
] as const;

export const REPORT_SUBMITTED_AGENCIES = [
  'Police Department',
  'JMO Office',
  'Ports Authority',
  'TSL Office',
  'Child Service Authority',
  'Health Ministry',
] as const;

export const REPORT_TASK_STATUSES = [
  'Assigned',
  'Completed',
  'Draft',
  'Escalated',
  'Forwarded',
  'Pending',
  'Rejected',
  'Reverted',
  'Submitted',
] as const;

export const REPORT_URGENCY_LEVELS = ['High', 'Medium', 'Low'] as const;

export const REPORT_WORKFLOW_STAGES = [
  'Allocation Officer Assignment',
  'Closure',
  'Legal Review',
  'Return to Allocation Officer',
  'Review',
  'Review & Process',
] as const;

export const REPORT_WORKFLOW_TEMPLATES = [
  'Criminal Advice Workflow',
  'Civil Advice Workflow',
  'Appellate Workflow',
  'Extradition Workflow',
  'RTI Workflow',
  'Criminal Litigation Workflow',
  'Civil Litigation Workflow',
  'Public Petition Workflow',
  'AG Advisory Workflow',
  'AGD Internal Workflow',
] as const;

export const REPORT_ALLOCATION_OFFICERS = [
  'K. Silva (DSG)',
  'R. Fernando',
  'A. Perera',
  'N. Jayasuriya',
  'S. Ranasinghe',
] as const;

export const userPerformanceReportData: UserPerformanceRow[] = [
  { id: '1', name: 'Mr. Nimal Silva', role: 'State Counsel', division: 'Criminal Division', assigned: 42, escalated: 3, completed: 21 },
  { id: '2', name: 'Ms. Shani Perera', role: 'Allocating Officer', division: 'Civil Division', assigned: 35, escalated: 1, completed: 22 },
  { id: '3', name: 'Mr. Raj Fernando', role: 'Supervising Officer', division: 'CH Division', assigned: 28, escalated: 2, completed: 17 },
  { id: '4', name: 'Ms. Aruni Peiris', role: 'Division Staff', division: 'Postal Division', assigned: 19, escalated: 0, completed: 12 },
  { id: '5', name: 'Ms. Ama Herath', role: 'State Attorney', division: 'Civil Division', assigned: 31, escalated: 4, completed: 13 },
  { id: '6', name: 'Mr. Kamal Dias', role: 'State Counsel', division: 'Civil Appellate Division', assigned: 24, escalated: 1, completed: 15 },
  { id: '7', name: 'Ms. Dilini Wijesinghe', role: 'Request Reviewer', division: 'Criminal Division', assigned: 16, escalated: 0, completed: 11 },
  { id: '8', name: 'Mr. Saman Perera', role: 'State Counsel', division: 'Criminal Division', assigned: 38, escalated: 2, completed: 19 },
  { id: '9', name: 'Ms. Kumari Silva', role: 'Allocating Officer', division: 'Civil Division', assigned: 22, escalated: 1, completed: 14 },
  { id: '10', name: 'Mr. Thilak Jayawardena', role: 'Supervising Officer', division: 'High Court Division', assigned: 30, escalated: 3, completed: 16 },
  { id: '11', name: 'Ms. Priya Senanayake', role: 'State Attorney', division: 'Supreme Court Division', assigned: 27, escalated: 0, completed: 18 },
  { id: '12', name: 'Mr. Ruwan Dissanayake', role: 'Division Staff', division: 'CH Division', assigned: 21, escalated: 1, completed: 13 },
];

export const caseTrackingReportData: CaseTrackingRow[] = [
  { id: '1', fileRef: 'SG-2024-0892', fileCategory: 'Criminal Division – Litigation', subFileCategory: 'Offence Affecting Human Body/Life', submittedAgency: 'Criminal Division', submittedAt: '2026-06-12', workflowStage: 'Drafting', allocationOfficer: 'K. Silva (DSG)', assignedOfficer: 'A. Perera', supervisor: 'K. Silva', taskStatus: 'Forwarded', urgencyLevel: 'High' },
  { id: '2', fileRef: 'SG-2024-0891', fileCategory: 'Civil Division – Advise', subFileCategory: 'C – Action Instituted by State', submittedAgency: 'Civil Division', submittedAt: '2026-06-11', workflowStage: 'Pending Review', allocationOfficer: 'K. Silva (DSG)', assignedOfficer: 'K. Silva', supervisor: 'R. Fernando', taskStatus: 'Forwarded', urgencyLevel: 'Medium' },
  { id: '3', fileRef: 'SG-2024-0890', fileCategory: 'Civil Division – Litigation', subFileCategory: 'L – Land Acquisition', submittedAgency: 'Supreme Court Registry', submittedAt: '2026-06-10', workflowStage: 'Filed in Court', allocationOfficer: 'R. Fernando', assignedOfficer: 'R. Fernando', supervisor: 'K. Silva', taskStatus: 'Completed', urgencyLevel: 'High' },
  { id: '4', fileRef: 'SG-2024-0889', fileCategory: 'Civil Division – Advise', subFileCategory: 'CA – Actions Against State', submittedAgency: 'Civil Division', submittedAt: '2026-06-10', workflowStage: 'Pending Review', allocationOfficer: '—', assignedOfficer: '—', supervisor: '—', taskStatus: 'Forwarded', urgencyLevel: 'Low' },
  { id: '5', fileRef: 'SG-2024-0888', fileCategory: 'Criminal Division – Advice', subFileCategory: 'CH – Child Abuse', submittedAgency: 'Criminal Division', submittedAt: '2026-06-09', workflowStage: 'Completed', allocationOfficer: 'S. Ranasinghe', assignedOfficer: 'S. Ranasinghe', supervisor: 'K. Silva', taskStatus: 'Completed', urgencyLevel: 'High' },
  { id: '6', fileRef: 'SG-2024-0887', fileCategory: 'Civil Litigation – Appellate Courts', subFileCategory: 'C – Civil Appeal', submittedAgency: 'Court of Appeal', submittedAt: '2026-06-08', workflowStage: 'Under Review', allocationOfficer: 'A. Perera', assignedOfficer: 'A. Perera', supervisor: 'R. Fernando', taskStatus: 'Reverted', urgencyLevel: 'High' },
  { id: '7', fileRef: 'SG-2024-0886', fileCategory: 'Extradition & Mutual Legal Assistance', subFileCategory: 'MLA – Treaty Request', submittedAgency: 'Ministry of Justice', submittedAt: '2026-06-07', workflowStage: 'Drafting', allocationOfficer: 'N. Jayasuriya', assignedOfficer: 'N. Jayasuriya', supervisor: 'K. Silva', taskStatus: 'Forwarded', urgencyLevel: 'Medium' },
  { id: '8', fileRef: 'SG-2024-0885', fileCategory: 'Criminal Litigation – Appellate Courts', subFileCategory: 'Offence Against Property', submittedAgency: 'Criminal Division', submittedAt: '2026-06-06', workflowStage: 'Pending Review', allocationOfficer: 'A. Perera', assignedOfficer: 'A. Perera', supervisor: 'R. Fernando', taskStatus: 'Escalated', urgencyLevel: 'High' },
  { id: '9', fileRef: 'SG-2024-0884', fileCategory: 'Right to Information', subFileCategory: 'RTI – State Entity', submittedAgency: 'RTI Commission', submittedAt: '2026-06-05', workflowStage: 'Assigned', allocationOfficer: 'S. Ranasinghe', assignedOfficer: 'S. Ranasinghe', supervisor: 'K. Silva', taskStatus: 'Forwarded', urgencyLevel: 'Low' },
  { id: '10', fileRef: 'SG-2024-0883', fileCategory: 'Public Petitions', subFileCategory: 'PP – Fundamental Rights', submittedAgency: 'Supreme Court', submittedAt: '2026-06-04', workflowStage: 'Under Review', allocationOfficer: 'K. Silva (DSG)', assignedOfficer: 'K. Silva', supervisor: '—', taskStatus: 'Reverted', urgencyLevel: 'Medium' },
  { id: '11', fileRef: 'SG-2024-0882', fileCategory: 'Civil Division – Litigation', subFileCategory: 'CA – Actions Against State', submittedAgency: 'High Court', submittedAt: '2026-06-03', workflowStage: 'Filed in Court', allocationOfficer: 'R. Fernando', assignedOfficer: 'R. Fernando', supervisor: 'K. Silva', taskStatus: 'Completed', urgencyLevel: 'Low' },
  { id: '12', fileRef: 'SG-2024-0881', fileCategory: 'Attorney General', subFileCategory: 'AG – Advisory Opinion', submittedAgency: 'Cabinet Secretariat', submittedAt: '2026-06-02', workflowStage: 'Drafting', allocationOfficer: 'N. Jayasuriya', assignedOfficer: 'N. Jayasuriya', supervisor: 'K. Silva', taskStatus: 'Forwarded', urgencyLevel: 'Medium' },
  { id: '13', fileRef: 'SG-2024-0880', fileCategory: 'Criminal Division – Advice', subFileCategory: 'Offence Affecting Human Body/Life', submittedAgency: 'Police Commission', submittedAt: '2026-06-01', workflowStage: 'Completed', allocationOfficer: 'A. Perera', assignedOfficer: 'A. Perera', supervisor: 'R. Fernando', taskStatus: 'Completed', urgencyLevel: 'Low' },
  { id: '14', fileRef: 'SG-2024-0879', fileCategory: 'Civil Division – Advise', subFileCategory: 'L – Land Dispute', submittedAgency: 'Land Commissioner', submittedAt: '2026-05-31', workflowStage: 'Pending Review', allocationOfficer: '—', assignedOfficer: '—', supervisor: '—', taskStatus: 'Requested to Re-allocate', urgencyLevel: 'Medium' },
  { id: '15', fileRef: 'SG-2024-0878', fileCategory: 'AGD – Internal', subFileCategory: 'Internal – Admin', submittedAgency: 'AGD', submittedAt: '2026-05-30', workflowStage: 'Completed', allocationOfficer: 'S. Ranasinghe', assignedOfficer: 'S. Ranasinghe', supervisor: 'K. Silva', taskStatus: 'Completed', urgencyLevel: 'Low' },
];

export const workflowPerformanceReportData: WorkflowPerformanceRow[] = [
  { id: '1', workflowCode: 'WF-CRIM-001', workflowTemplateName: 'Criminal Advice Workflow', workflowTemplateStatus: 'Active', fileCategory: 'Criminal Division – Advice', subFileCategory: 'Offence Affecting Human Body/Life', allocationOfficer: 'K. Silva (DSG)', workflowStage: 'Drafting', casesReceived: 48, completed: 21, inProgress: 18, overdue: 5, escalated: 4 },
  { id: '2', workflowCode: 'WF-CIV-001', workflowTemplateName: 'Civil Advice Workflow', workflowTemplateStatus: 'Active', fileCategory: 'Civil Division – Advise', subFileCategory: 'C – Action Instituted by State', allocationOfficer: 'R. Fernando', workflowStage: 'Pending Review', casesReceived: 62, completed: 28, inProgress: 22, overdue: 8, escalated: 4 },
  { id: '3', workflowCode: 'WF-APP-001', workflowTemplateName: 'Appellate Workflow', workflowTemplateStatus: 'Active', fileCategory: 'Civil Litigation – Appellate Courts', subFileCategory: 'C – Civil Appeal', allocationOfficer: 'A. Perera', workflowStage: 'Under Review', casesReceived: 35, completed: 17, inProgress: 12, overdue: 4, escalated: 2 },
  { id: '4', workflowCode: 'WF-EXT-001', workflowTemplateName: 'Extradition Workflow', workflowTemplateStatus: 'Active', fileCategory: 'Extradition & MLA', subFileCategory: 'MLA – Treaty Request', allocationOfficer: 'N. Jayasuriya', workflowStage: 'Drafting', casesReceived: 22, completed: 9, inProgress: 8, overdue: 3, escalated: 2 },
  { id: '5', workflowCode: 'WF-RTI-001', workflowTemplateName: 'RTI Workflow', workflowTemplateStatus: 'Active', fileCategory: 'Right to Information', subFileCategory: 'RTI – State Entity', allocationOfficer: 'S. Ranasinghe', workflowStage: 'Assigned', casesReceived: 18, completed: 10, inProgress: 5, overdue: 2, escalated: 1 },
  { id: '6', workflowCode: 'WF-CRIM-LIT-001', workflowTemplateName: 'Criminal Litigation Workflow', workflowTemplateStatus: 'Active', fileCategory: 'Criminal Division – Litigation', subFileCategory: 'Offence Against Property', allocationOfficer: 'A. Perera', workflowStage: 'Filed in Court', casesReceived: 41, completed: 19, inProgress: 14, overdue: 6, escalated: 2 },
  { id: '7', workflowCode: 'WF-CIV-LIT-001', workflowTemplateName: 'Civil Litigation Workflow', workflowTemplateStatus: 'Active', fileCategory: 'Civil Division – Litigation', subFileCategory: 'L – Land Acquisition', allocationOfficer: 'R. Fernando', workflowStage: 'Filed in Court', casesReceived: 55, completed: 31, inProgress: 16, overdue: 5, escalated: 3 },
  { id: '8', workflowCode: 'WF-PP-001', workflowTemplateName: 'Public Petition Workflow', workflowTemplateStatus: 'Active', fileCategory: 'Public Petitions', subFileCategory: 'PP – Fundamental Rights', allocationOfficer: 'K. Silva (DSG)', workflowStage: 'Under Review', casesReceived: 14, completed: 6, inProgress: 5, overdue: 2, escalated: 1 },
  { id: '9', workflowCode: 'WF-AG-001', workflowTemplateName: 'AG Advisory Workflow', workflowTemplateStatus: 'Active', fileCategory: 'Attorney General', subFileCategory: 'AG – Advisory Opinion', allocationOfficer: 'N. Jayasuriya', workflowStage: 'Drafting', casesReceived: 12, completed: 5, inProgress: 4, overdue: 2, escalated: 1 },
  { id: '10', workflowCode: 'WF-AGD-INT-001', workflowTemplateName: 'AGD Internal Workflow', workflowTemplateStatus: 'Active', fileCategory: 'AGD – Internal', subFileCategory: 'Internal – Admin', allocationOfficer: 'S. Ranasinghe', workflowStage: 'Completed', casesReceived: 9, completed: 9, inProgress: 0, overdue: 0, escalated: 0 },
  { id: '11', workflowCode: 'WF-CRIM-CH-001', workflowTemplateName: 'Criminal Advice Workflow', workflowTemplateStatus: 'Active', fileCategory: 'Criminal Division – Advice', subFileCategory: 'CH – Child Abuse', allocationOfficer: 'S. Ranasinghe', workflowStage: 'Completed', casesReceived: 30, completed: 22, inProgress: 6, overdue: 1, escalated: 1 },
  { id: '12', workflowCode: 'WF-CRIM-APP-001', workflowTemplateName: 'Appellate Workflow', workflowTemplateStatus: 'Active', fileCategory: 'Criminal Litigation – Appellate', subFileCategory: 'Offence Against Property', allocationOfficer: 'A. Perera', workflowStage: 'Pending Review', casesReceived: 26, completed: 11, inProgress: 9, overdue: 4, escalated: 2 },
];

export function matchesMultiSelect(selected: string[], value: string) {
  if (selected.length === 0) return true;
  return selected.some((s) => value.toLowerCase().includes(s.toLowerCase()) || s.toLowerCase().includes(value.toLowerCase()));
}

export function matchesDateRange(isoDate: string, from: string, to: string) {
  if (!from && !to) return true;
  const d = isoDate.slice(0, 10);
  if (from && d < from) return false;
  if (to && d > to) return false;
  return true;
}
